var map = {
	"./al.PNG": "./src/images/Home/al.PNG",
	"./ashlogo2.png": "./src/images/Home/ashlogo2.png",
	"./bulgariahospital.jpg": "./src/images/Home/bulgariahospital.jpg",
	"./dan.PNG": "./src/images/Home/dan.PNG",
	"./dannew.PNG": "./src/images/Home/dannew.PNG",
	"./default-image.jpg": "./src/images/Home/default-image.jpg",
	"./email-svgrepo-com.svg": "./src/images/Home/email-svgrepo-com.svg",
	"./facebook.png": "./src/images/Home/facebook.png",
	"./gab.PNG": "./src/images/Home/gab.PNG",
	"./hospital2new.PNG": "./src/images/Home/hospital2new.PNG",
	"./il.PNG": "./src/images/Home/il.PNG",
	"./il.jpeg": "./src/images/Home/il.jpeg",
	"./il.jpg": "./src/images/Home/il.jpg",
	"./instagram.png": "./src/images/Home/instagram.png",
	"./kyivhospital.jpg": "./src/images/Home/kyivhospital.jpg",
	"./linkedin.png": "./src/images/Home/linkedin.png",
	"./lvivhospital.jpg": "./src/images/Home/lvivhospital.jpg",
	"./mainimage.png": "./src/images/Home/mainimage.png",
	"./n.jpg": "./src/images/Home/n.jpg",
	"./sash.PNG": "./src/images/Home/sash.PNG",
	"./vald.PNG": "./src/images/Home/vald.PNG",
	"./wheat_field.png": "./src/images/Home/wheat_field.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/Home sync recursive ^\\.\\/.*$";